import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import {
  HideRetailerAgnosticStoreConfigs,
  ViewType,
} from '@retailer-platform/dashboard/gin-and-tonic'
import { DomainRoute } from '../utils/domain/routingComponents'
import { notificationsAccessControl } from '../access-control/notificationsAccess.configuration'
import { emailLogAccessControl } from '../access-control/emailLogAccess.configuration'
import { NotificationSettings } from '../pages/list/settings/NotificationSettings'

const EmailLogListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "EmailLogListPage" */
      '../pages/email-log/EmailLogListPage'
    )
)
// @hygen:inject page-import

// Partner Scoped Routes
export const notificationsSettingsRouter = (
  <DomainRoute route="notifications-settings" accessControl={notificationsAccessControl}>
    <DashSwitch>
      <DomainRoute route="notifications-settings" component={NotificationSettings} />
    </DashSwitch>
  </DomainRoute>
)

// Scoped Routes — Email Log
export const emailLogRouter = (
  <DomainRoute route="email-log" accessControl={emailLogAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="email-log"
        tool="notifications-email-log-dashboard-tool"
        component={EmailLogListPage}
        scopePicker={{
          titles: ['notificationsDomain.emailLog.pageTitle'],
          selectionType: ViewType.RETAILER_AND_STORE_CONFIG,
          storeConfigFilter: HideRetailerAgnosticStoreConfigs,
        }}
      />
    </DashSwitch>
  </DomainRoute>
)
